export default {
  namespaced: true,
  state: {
    isAuthorize: false,
    purchaseId: null,
    addressId: null,
    fillAddress: null,
    fillKYC: null,
    isCompleteAddr: false,
    isCompleteOrd: false,
    totalPrice: 0,
    discount: 0,
    addressList: [],
    checkoutItemList: [],
    fromWhichPage: '',
    addressChange: false,
    isNewCustomerGuidePopupOpened: false,
    isAddAddress: false
  },
  mutations: {
    setFillAddress(state, data) {
      state.fillAddress = data;
    },
    setFillKYC(state, data) {
      state.fillKYC = data;
    },
    setAddressList(state, data) {
      // Later modifications will be made
      localStorage.setItem('addressList', JSON.stringify(data));
      state.addressList = data;
    },
    setIsAuthorize(state, data) {
      state.isAuthorize = data;
    },
    setCheckoutItemList(state, data) {
      state.checkoutItemList = data;
    },
    setPurchaseId(state, data) {
      state.purchaseId = data;
    },
    setAddressId(state, data) {
      state.addressId = data;
    },
    setIsCompleteAddr(state, data) {
      state.isCompleteAddr = data;
    },
    setIsCompleteKyc(state, data) {
      state.isCompleteKyc = data;
    },
    setTotalPrice(state, data) {
      state.totalPrice = data;
    },
    setDiscount(state, data) {
      state.discount = data;
    },
    setFromPage(state, data) {
      state.fromWhichPage = data;
    },
    setAddressChange(state, data) {
      state.addressChange = data;
    },
    setIsNewCustomerGuidePopupOpened(state, data) {
      state.isNewCustomerGuidePopupOpened = data;
    },
    setIsAddAddress(state, data) {
      state.isAddAddress = data;
    }
  },
  getters: {
    getDefaultAddress(state) {
      const list = state.addressList;
      const item = list?.find(i => i.isDefault);
      if (!item) {
        return list?.length > 0 ? list[0] : null;
      }
      return item;
    },
    getCheckoutItemList(state) {
      return state.checkoutItemList?.length > 0
        ? state.checkoutItemList
        : JSON.parse(sessionStorage.getItem('checkoutItemList'));
    }
  }
};
